import ReactNative from 'react-native';
const { DeviceSetup } = ReactNative.NativeModules;

export const clearSpotifyAppData = async (): Promise<boolean> => {
  const { PACKAGE_NAME_SPOTIFY } = DeviceSetup.getConstants();
  return clearAppData(PACKAGE_NAME_SPOTIFY);
};

async function clearAppData(packageName: string): Promise<boolean> {
  return await DeviceSetup.clearAppData(packageName);
}
